import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const modules = {}
const requireContext = require.context('./modules', true, /.*\/$/)
requireContext.keys().forEach(file => {
    modules[file.replace(/\.|\//g, '')] = requireContext(file).default
})

const store = new Vuex.Store({modules})
export default store
